import React, { useEffect } from 'react';
import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import InviteCode from './InviteCode';
import { getPathAfterGuestAuthFailure } from '../utils/guestAuthRedirect';

export default function GuestHome() {
  const { galleryId = '' } = useParams();
  const navigate = useNavigate();
  const {
    isAuthenticated,
    setIsAuthenticated,
    clearGuestAuthFailure,
    logoUrl,
    authFailure,
  } = useOutletContext();
  const dashboardPath = `${getPathAfterGuestAuthFailure(galleryId)}/dashboard`;
  const returnTo =
    authFailure?.galleryId === galleryId &&
    (authFailure.returnTo === dashboardPath ||
      authFailure.returnTo?.startsWith(`${dashboardPath}/`) ||
      authFailure.returnTo?.startsWith(`${dashboardPath}?`))
      ? authFailure.returnTo
      : 'dashboard';

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }
    navigate(returnTo, { replace: true });
    return () => clearGuestAuthFailure?.();
  }, [clearGuestAuthFailure, isAuthenticated, navigate, returnTo]);

  if (isAuthenticated) {
    return null;
  }
  return (
    <InviteCode
      setAuth={setIsAuthenticated}
      logo={logoUrl}
      authFailureReason={authFailure?.reason}
    />
  );
}
